import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-create-grow-account",
	imports: [COMMON_IMPORTS, CancelBtnComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button class="btn btn-primary">
				<a
					href="https://airtable.com/appDxqmg4PezmVLuY/shrMhtF6FjZKIt2Vx"
					style="color:#fff;"
					target="”_blank”"
				>
					{{ "create_grow_account" | langVal }}
				</a>
			</button>
		</div>
	`,
})
export class CreateGrowAccountComponent extends Modalable {}
